import { render, staticRenderFns } from "./SingleProduct.vue?vue&type=template&id=54a88d90"
import script from "./SingleProduct.vue?vue&type=script&lang=js"
export * from "./SingleProduct.vue?vue&type=script&lang=js"
import style0 from "./SingleProduct.vue?vue&type=style&index=0&id=54a88d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports